module.exports = __webpack_public_path__ + "img/Doelgroep - ondersteuende communicatie.67f438ec.webp";